import React, { useState, useEffect } from 'react'
import { Modal, Box, Typography, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material'
import axiosInstanceMainUrl from '../../utils/axiosInstanceMainUrl'
import Swal from 'sweetalert2'
import Loader from '../customTable/Loader'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: 'white',
  boxShadow: 24,
  padding: '24px',
}

export default function MuiSelectionModal({
  open,
  onClose,
  value = '',
  onChange,
  formData,
  setFormData,
  getlistofusers,
}) {
  const [status, setStatus] = useState(value)
  const [loading, setLoading] = useState(false);

  // Sync with parent value
  useEffect(() => {
    setStatus(value)
  }, [value])




  // const handleChange = async (event) => {
  //   console.log("Triggered", event.target.value);
  //   const newValue = event.target.value;

  //   setStatus(newValue);
  //   setFormData((prev) => ({ ...prev, status: newValue }));

  //   setLoading(true);

  //   try {
  //     const res = await axiosInstanceMainUrl.post('/api/admin/updateNameMismatchStatus', {
  //       customerRefNo: formData.customerRefNo,
  //       status: newValue, 
  //     });
  //    console.log('API response:', res.data);
  //     if (res.error) {
  //       throw new Error(res.data.message || 'Failed to update status');
  //     }
  //     setLoading(false);
  //     onClose(); 
  //     await Swal.fire({
  //       icon: 'success',
  //       title: 'Updated!',
  //       text: 'Status updated successfully',
  //       timer: 2000,
  //       showConfirmButton: false,
  //     });
  //       getlistofusers();
  //     if (onChange) onChange(newValue);

  //   } catch (error) {
  //     console.error('API error:', error);

  //     await Swal.fire({
  //       icon: 'error',
  //       title: 'Failed!',
  //       text: error?.response?.data?.message || 'Something went wrong',
  //     });

  //   } finally {
  //     setLoading(false); 
  //     onClose(); 
  //     setFormData({
  //       customerRefNo: "",
  //       status: "",
  //     })
  //   }
  // };

  const handleChange = (event) => {
    const newValue = event.target.value;

   
    onClose();
    setTimeout(async () => {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to change status to "${newValue}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "Cancel",
        target: document.body, // 🔥 FIX
      });

      if (!result.isConfirmed) {
        return;
      }

     
      setStatus(newValue);
      setFormData((prev) => ({ ...prev, status: newValue }));
      setLoading(true);

      try {
         console.log('payload:-----------------------------------------',formData.id,newValue);
        const res = await axiosInstanceMainUrl.post(
          '/api/admin/updateNameMismatchStatus',
          {
            id: formData.id,
            status: newValue,
          }
        );
      console.log('payload:-----------------------------------------',formData.id,newValue);
        if (res.data.error) {
          throw new Error(res.data.message || 'Failed to update status');
        }

        await Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: 'Status updated successfully',
          timer: 2000,
          showConfirmButton: false,
        });
   
        getlistofusers();
        if (onChange) onChange(newValue);

      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: error?.response?.data?.message || 'Something went wrong',
        });
      } finally {
        setLoading(false);
        onClose();
        setFormData({
          id: "",
          status: "",
        });
      }
    }, 0); // 🔥 important
  };

 
  const handleClose = () => {
    onClose()
    setStatus('')

  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEnforceFocus   // 🔥 ADD THIS
    >
      <Box sx={{ ...style, position: 'relative' }}>


        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <Loader />
          </Box>
        )}


        <Typography variant="h6">
          Select Status
        </Typography>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            label="Status"
            onChange={handleChange}
            disabled={loading}
          >

            <MenuItem value="Open">Open</MenuItem>
            <MenuItem value="Processing">Processing</MenuItem>
            <MenuItem value="Close">Close</MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleClose}
          disabled={loading}
        >
          Close
        </Button>

      </Box>
    </Modal>
  );
}